import { isProd } from '../../utils/env';
export const ESSENTIAL_APPS_FOR_DATA_ACTIVATION = isProd() ? 652035 : undefined;
export const ESSENTIAL_APPS_FOR_SALES = isProd() ? 556033 : undefined;
export const APPS_FOR_BREEZE_STUDIO = isProd() ? 652038 : undefined;
export const APPS_FOR_BREEZE_ASSISTANT = isProd() ? 645033 : undefined;
export const LLM_CUSTOM_WORKFLOW_ACTIONS = isProd() ? 652037 : undefined;